<template>
  <div
    :class="`
      ${configData.Spacing !== undefined ? 'pt-' + configData.Spacing : ''}
      ${configData.MediumSpacing !== undefined ? 'md:pt-' + configData.MediumSpacing : ''}
      ${configData.LargeSpacing !== undefined ? 'lg:pt-' + configData.LargeSpacing : ''}
  `"
  ></div>
</template>

<script lang="ts" setup>
interface Props {
  configData: {
    Spacing?: number;
    MediumSpacing?: number;
    LargeSpacing?: number;
    FullBackground?: boolean;
  };
}

defineProps<Props>();
</script>

<style></style>
